// src/context/AuthContext.js
import React, { createContext, useContext, useEffect, useState } from 'react';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem('accessToken'));
  const [userEmail, setUserEmail] = useState(localStorage.getItem('userEmail'));

  const [Useraddress, setUseraddress] = useState(() => {
    const savedAddress = localStorage.getItem('Useraddress');
    return savedAddress ? JSON.parse(savedAddress) : { street: '', city: '', state: '', pincode: '' };
  });
  const [UserselectedProduct, setUserselectedProduct] = useState(() => {
    const savedProduct = localStorage.getItem('UserselectedProduct');
    return savedProduct ? JSON.parse(savedProduct) : null;
  });


 // const [UserselectedProduct, setUserselectedProduct] = useState(null);

  const login = (email, token) => {
    setIsAuthenticated(true);
    setUserEmail(email);
    localStorage.setItem('accessToken', token);
    localStorage.setItem('userEmail', email);
  };

  const logout = () => {
    setIsAuthenticated(false);
    setUserEmail(null);
    localStorage.removeItem('accessToken');
    localStorage.removeItem('userEmail');
  };
  console.log("Useraddress:", Useraddress); // Debug log
  console.log("UserselectedProduct:", UserselectedProduct); // Debug log
  useEffect(() => {
    localStorage.setItem('Useraddress', JSON.stringify(Useraddress));
  }, [Useraddress]);

  useEffect(() => {
    localStorage.setItem('UserselectedProduct', JSON.stringify(UserselectedProduct));
  }, [UserselectedProduct]);
  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        userEmail,
        login,
        logout,
        Useraddress,
        setUseraddress,
        UserselectedProduct,
        setUserselectedProduct,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
